import { DealStatus, HasDeal } from '@business/entities/deal';

export function getStatusTitle(status: DealStatus) {
  switch (status) {
    case DealStatus.all:
      return 'All';
    case DealStatus.inProgress:
      return 'In Progress';
    case DealStatus.hot:
      return 'Hot';
    case DealStatus.warm:
      return 'Warm';
    case DealStatus.cool:
      return 'Cool';
    case DealStatus.cold:
      return 'Cold';
    case DealStatus.won:
      return 'Won';
    case DealStatus.lost:
      return 'Lost';
    case DealStatus.deleted:
      return 'Deleted';
    case DealStatus.reopen:
      return 'Reopen';
    case DealStatus.open:
      return 'Open';
    case DealStatus.cancelled:
      return 'Cancelled';
    case DealStatus.referred:
      return 'Refer Out';
  }
  return 'Unknown';
}

export function getStatusEmoji(status: DealStatus) {
  switch (status) {
    case DealStatus.inProgress:
      return 'meh';
    case DealStatus.won:
      return 'smile';
    case DealStatus.lost:
      return 'frown';
    case DealStatus.deleted:
      return 'frown';
  }
  return 'Unknown';
}

export function getStatusColor(status: DealStatus) {
  switch (status) {
    case DealStatus.inProgress:
      return 'text-dark';
    case DealStatus.won:
      return 'text-success';
    case DealStatus.lost:
      return 'text-danger';
    case DealStatus.deleted:
      return 'text-danger';
  }
  return 'Unknown';
}

export function allStatuses() {
  return [
    DealStatus.inProgress,
    DealStatus.open,
    DealStatus.hot,
    DealStatus.warm,
    DealStatus.cool,
    DealStatus.cold,
    DealStatus.won,
    DealStatus.lost,
    DealStatus.deleted,
    DealStatus.cancelled,
    DealStatus.referred,
  ];
}

// Deal board status filter: real statuses plus the "All" pseudo-status.
// Kept separate from allStatuses() — that list feeds report filters where "All" is invalid.
export function boardFilterStatuses() {
  return [DealStatus.all, ...allStatuses()];
}

export function overlayStatuses() {
  return [
    DealStatus.inProgress,
    DealStatus.open,
    DealStatus.hot,
    DealStatus.warm,
    DealStatus.cool,
    DealStatus.cold,
    DealStatus.won,
    DealStatus.lost,
    DealStatus.cancelled,
    DealStatus.referred,
  ];
}

export function getHasDealTitle(hasDeal: HasDeal) {
  switch (hasDeal) {
    case HasDeal.all:
      return 'All';
    case HasDeal.yes:
      return 'Has Deal';
    case HasDeal.no:
      return 'No Deal';
  }
}
